import { LollyError } from "app/models/base.model";
import { HttpService } from "./http.service";
import { ServiceProvider } from "./service.provider";

export abstract class BaseService extends HttpService {
	
	constructor(public endpoint: string, public provider: ServiceProvider) {
		super(endpoint, provider.http);
	}

	protected getList(method?: string, limit?: number, page?: number) {
		if (limit != undefined && limit != null && page != undefined && page != null) {
			method = method + "?limit=" + limit + "&page=" + page;
		}

		return new Promise((resolve, reject) => {
			this.get(method).subscribe(
				(response) => {
					this.processResponse(resolve, reject, response);
				},

				(err) => {
					reject(this.processError(err));
				}
			);
		});
	}

	 getById(id) {
		return this.getRecord("/" + id);
	}

	protected getRecord(method: string) {
		return new Promise((resolve, reject) => {
			this.get(method).subscribe(
				(response) => {
					this.processResponse(resolve, reject, response);
				},
				(err) => {
					reject(this.processError(err));
				}
			);
		});
	}
	protected save(data, method?:string) {
		return new Promise((resolve, reject) => {
			this.post(data, method).subscribe(
				(response) => {
					this.processResponse(resolve, reject, response);
				},
				(err) => {
					reject(this.processError(err));
				}
			);
		});
	}

	protected saveCookie(data, method?:string) {
		return new Promise((resolve, reject) => {
			this.post(data, method).subscribe(
				(response) => {
					this.processResponse(resolve, reject, response);
				},
				(err) => {
					reject(this.processError(err));
				}
			);
		});
	}

	protected saveGlobal(data, method?) {
		return new Promise((resolve, reject) => {
			this.postGlobal(data, method).subscribe(
				(response) => {
					this.processResponse(resolve, reject, response);
				},
				(err) => {
					reject(this.processError(err));
				}
			);
		});
	}

	protected update(data, method?: string) {
		return new Promise((resolve, reject) => {
			this.patch(method,data ).subscribe(
				(response) => {
					this.processResponse(resolve, reject, response);
				},
				(err) => {
					reject(this.processError(err));
				}
			);
		});
	}

	protected patchdata(endpoint: string, data: any) {
		return new Promise((resolve, reject) => {
			this.patch(endpoint, data).subscribe(
				(response) => {
					this.processResponse(resolve, reject, response);
				},
				(err) => {
					reject(this.processError(err));
				}
			);
		});
	}

	public deleteRecord(id) {
		return new Promise((resolve, reject) => {
			this.delete(id).subscribe(
				(response) => {
					this.processResponse(resolve, reject, response);
				},
				(err) => {
					reject(this.processError(err));
				}
			);
		});
	}

	private processResponse(resolve, reject, response) {
		
		if (response.status === "SUCCESSFUL") 
		{
			resolve(response);
		} else {
			const error = response?.error ?? {error:response}
			reject(this.processError(error));
		}
	}

	protected processError(error) {
		//console.log(" ----------Exception from server side Base Service--------- ");
		const err = new LollyError(error)
		if (!this.isOnline()) {
			err.message =
				'Server connection error! please check your internet connection and try again or <a href="mailto:support@dms_lollylaw.com">contact support</a> for further assistance';
			this.provider.showError(err.message);
			return err;
		} else if (err.code === "403") {
			this.provider.accessDenied(err.message);
		} else if (err.code === "1301") {
		} else if (err.code === "1302") {
			// this.provider.util.logout("session-expire", this.getHeaders().get("LOLLY_USER_TYPE"));
			// this.provider.logout();
		} else {
			if (!err.message || err.message.trim() == "") {
				this.provider.showError('Unexpected error! please try again or <a href="mailto:support@lollylaw.com">contact support</a> for further assistance');
			} else {
				this.provider.showError(err.message);
			}
			return err;
		}
	}

	public getData(res: any) {
		// console.log("getData", res);
		return res.data??res
	}

	public getMeta(res: any) {
		return res.meta;
	}

	public getSimData(res: any) {
		return res;
	}

	public getCount(res : any){
		return res.count;
	}

	isOnline(): boolean {
		return navigator.onLine;
	}

}
